import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export function LineMask({ children, delay = 0, className = "", as = "span" }) {
  return (
    <span className={`block overflow-hidden pb-[0.12em] -mb-[0.12em] ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "115%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.8, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function FadeIn({ children, delay = 0, y = 32, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.8, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function SectionTag({ children, dark = true }) {
  return (
    <div className="flex items-center gap-3 mb-6">
      <span className="h-px w-10 bg-neon" aria-hidden="true" />
      <span className={`text-xs font-semibold uppercase tracking-[0.3em] ${dark ? "text-neon" : "text-sky-brand"}`}>
        {children}
      </span>
    </div>
  );
}

export const pageTransition = {
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: EASE },
};
